/*
  This hook encapsulates a field isError logic with formik

  Used like - const isError = useFieldError({ touched, errors, field, submitCount })
*/

import { useMemo } from 'react';

function useFieldError({
  touched = {}, errors = {}, field = {}, submitCount = 0
}) {
  return useMemo(() => (
    submitCount > 0 && field.name
      ? errors[field.name]
      : touched[field.name] && errors[field.name]),
  [
    touched,
    errors,
    field.name,
    submitCount,
  ]);
}

export default useFieldError;
